import { render, staticRenderFns } from "./GermplasmTraitStats.vue?vue&type=template&id=28976792&"
import script from "./GermplasmTraitStats.vue?vue&type=script&lang=js&"
export * from "./GermplasmTraitStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports